import styled from 'styled-components';
import Icon from '@ant-design/icons';

export const AnchorIcon = styled(Icon)`
  margin-left: 5px;
  padding: 5px;
  width: 30px;
  height: 30px;
`;

export const ItemContent = styled.p`
  margin: 0 5px;
  padding-left: 5px;
  word-break: break-word;
  white-space: normal;
  width: 250px;
`;

export const StyledNoData = styled.div`
  padding-top: 10px;
  height: 240px;
`;

export const MetricSelector = styled.div`
  max-height: 330px;
  width: 400px;
  padding: 10px;
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 5px;

  .menu-ul {
    margin-top: 5px;
    box-shadow: none;
    height: 240px;
    overflow-y: auto;
    text-align: left;

    .ant-dropdown-menu-item-active {
      background: none !important;
    }

    .ant-dropdown-menu-item-group-title {
      padding: 5px 0;
    }
  }

  .bottom-space {
    display: flex;
    padding: 8px 0;
    align-items: center;
    justify-content: space-between;
  }

  .dimension-wrapper {
    padding: 0 !important;
    display: flex;
    flex-direction: row;

    .ant-checkbox-wrapper {
      padding: 5px 7px;
      border-radius: 5px;

      &:hover {
        background-color: #0000000a;
      }
    }
  }

  & > li {
    margin-top: 0;
    margin-bottom: 0 !important;
  }
`;
